
$('.close-mob, .mob-menu').on('click', function () {
   $('.mob-header-menu').slideToggle(300)
   $(this).toggleClass('active')
   $('body').toggleClass('overflow-hidden')
});

$('[href="#"]').on('click', function (e) {
   e.preventDefault();
});


$('.drop').on('click', function (e) {
   e.preventDefault();
   $(this).siblings('ul').slideToggle(300)
   $(this).toggleClass('active')
});



if ($(window).width() > 767) {
   if ($(document).scrollTop() > 10) {
      $('header').addClass('fx')
   }

   $(document).on('scroll', function () {
      if ($(document).scrollTop() > 10) {
         setTimeout(function () {
            $('header').addClass('fx')
         }, 200)
      } else {
         setTimeout(function () {
            $('header').removeClass('fx')
         }, 200)
      }
   });
}